import { Action } from "@ngrx/store/src/models";
import { SystemPermissionModel } from "../../models/SystemPermissionModel";

export const QUERY_AVAILABLE_PERMISSIONS_SUCCESS = "[SecurityModule] Query Available Permissions Success";

export class QueryAvailablePermissionsSuccessAction implements Action {
  readonly type: string;

  constructor(public payload: { items: SystemPermissionModel[] }) {
    this.type = QUERY_AVAILABLE_PERMISSIONS_SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/QueryAvailablePermissionsSuccessAction.ts